import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import router from "./router";
import { Loading } from "@/components/Loading";

const routerStack = createBrowserRouter(router);

export default function RouterStackProvider() {
  return (
    <Suspense fallback={<Loading.Absolute />}>
      <RouterProvider
        router={routerStack}
        future={{
          v7_startTransition: true,
        }}
      />
    </Suspense>
  );
}
